import {CallFunction} from "../../public/bundles/w3comhulk/callFunction";

export const provideTransporterList = (rows, isAfterSales) => {
    let callFunction = new CallFunction('provideTransporterList', 'fad fa-truck');
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = ''
    callFunction.showModal('Sélection de transporteur')
    callFunction.startLoading();
    let data = rows.toArray();

    if (data.length === 0) {
        callFunction.modalBody.innerHTML = '<span class="text-danger">Vous devez sélectionner au moins un vehicule.</span>';
        callFunction.stopLoading();
        return;
    }

    let cardCode = {
        'cardCode' : data[0]['CardCodeAcheteur'],
    }

    $.ajax({
        type: 'POST',
        data: cardCode,
        url: urls.provideTransporterList,

        success: function (response) {
            callFunction.modalBody.innerHTML = response;
            callFunction.stopLoading();
            callFunction.modalFooter.innerHTML = '<button id="createTransportPurchaseOrderValidationButton" class="btn btn-success">Valider</button>'
            $('#createTransportPurchaseOrderValidationButton').on('click', function() {
                if (typeof isAfterSales === 'undefined') {
                    createTransportPurchaseOrder(data, callFunction, 0);
                } else {
                    createTransportPurchaseOrder(data, callFunction, 1);
                }
            })
        }
    })
}

export const createTransportPurchaseOrder = (rows, callFunction, isAfterSales) => {
    let transporter = $('#transporter-select').val();
    let shipping = $('#shipping-select').val();
    let rowsToJson = JSON.stringify(rows)
    callFunction.startLoading();

    let data = {
        'data': rowsToJson,
        'transporter': transporter,
        'isAfterSales': isAfterSales,
        'shipping': shipping,
    }

    $.ajax({
        type: 'POST',
        data: data,
        url: urls.createTransportPurchaseOrder,
        success: function (response) {
            callFunction.modalBody.innerHTML = '';
            if (response.success) {
                callFunction.addLineResult(response.success, 'success');
                let docEntryPurchaseOrder = response.docEntryPurchaseOrder
                // Open Sap Form after creating à transport purchase order
                openForm('OPOR', docEntryPurchaseOrder[0].toString())
            } else if (response.error) {
                callFunction.addLineResult(response.error, 'danger');
            }
            callFunction.stopLoading();
            callFunction.modalFooter.innerHTML = '<button class="btn btn-primary" data-dismiss="modal">Fermer</button>';
        }
    });
};

export const updateSapLineAndVehicleShipDateAndCreatePurchaseDeliveryNotes = (row, input, isAfterSales) => {
    if (input.className.indexOf('is-valid') !== -1) {
        input.className = input.className.replace('is-valid', '');
    }
    if (input.className.indexOf('is-invalid') !== -1) {
        input.className = input.className.replace('is-invalid', '');
    }
    input.setAttribute('disabled', true);

    let data = {
        'row': row,
        'affectedValue': input.value
    };

    let url = urls.updateSapLineAndVehicleShipDateAndCreatePurchaseDeliveryNotes

    if (typeof isAfterSales !== 'undefined') {
        url = urls.updateSapLineAndVehicleShipDateAndCreatePurchaseDeliveryNotesAfterSales
    }

    $.ajax({
        method: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        success: function () {
            input.setAttribute('disabled', false);
            input.className += ' is-valid';
            // Refresh flash div to display it
            updateFlashMessageDivs();
        },
        error: function () {
            input.setAttribute('disabled', false);
            input.className += ' is-invalid';
            // Refresh flash div to display it
            updateFlashMessageDivs();
        }
    });
};

function updateFlashMessageDivs() {
    $( "#flash" ).load(window.location.href + " #flash" );
}



// WEBPACK FOOTER //
// ./assets/js/display_gestion_transport.js